// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-container":"Breadcrumb_breadcrumb-container__pLQZp","item":"Breadcrumb_item__dtT9K"};